import React, { Fragment, useEffect, useState } from 'react'
import {
  Form,
  Button,
  Select,
  Input,
  Tooltip,
  Row,
  Col,
  Tabs,
  List,
  Avatar,
  message,
  Modal,
  Progress,
  Spin,
  Radio,
  Tag
} from 'antd'
import {
  SoundOutlined,
  PlusCircleOutlined,
  MutedOutlined,
  LeftOutlined,
  DeleteOutlined,
  LoadingOutlined,
  CheckCircleTwoTone,
  MessageOutlined,
  SendOutlined,
  EnterOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined
} from '@ant-design/icons'
import './DiscussionCreateMachine.scss'
import { useTranslation } from 'react-i18next'
import { ImageSelect } from '../../../../components/Form'
import FileUploadComponent from '../components/UploadFiles/UploadFiles'
import './DiscussionCreateMachine.scss'
import actions from '../../../../store/actions'
import { useDispatch } from 'react-redux'
import ReactPlayer from 'react-player'
import {
  AudioIcon,
  AudioModalTitleIcon
} from '../../../Courses/Create/nestedComponents/PageConstructor/internal/PageMaker/components/Icons'
import FooterActions from '../../../Courses/Create/nestedComponents/PageConstructor/internal/PageMaker/components/FooterActions'
import Audio from '../../../Courses/Create/nestedComponents/PageBuilder/Components/Audio'
import _ from 'lodash'
import { useRef } from 'react'
import {
  CreateAudio,
  AddDetailAudio
} from '../../../Courses/Create/nestedComponents/PageBuilder/Components/Audio/internal/Create'
import debounce from 'lodash/debounce'
import { useCallback } from 'react'
import { deactiveSoundIcon } from '../../../Courses/Create/nestedComponents/PageBuilder/Components/Audio/images'
import Dropzone from 'react-dropzone'
import { api } from '../../../../services'
import { FileUpload } from '../../../../components'
import TextEditor from '../components/TextEditor/TextEditor'

const { Option, OptGroup } = Select
const { TabPane } = Tabs
const DiscussionCreateMachine = ({
  activeOrganizationId = null,
  form,
  open,
  onFinish,
  close,
  roomName,
  description,
  selectedCover,
  library,
  upload,
  clearUploadList,
  changePodcastDescription,
  previousPodcast = []
}) => {
  const audioRef = useRef(null)
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const scrollContainerRef = useRef(null)
  const [dotCount, setDotCount] = useState(0)
  const [contentSource, setContentSource] = useState('internet')
  const [streamedText, setStreamedText] = useState('')
  const [isStreaming, setIsStreaming] = useState(false)
  const [IsStreamVisible, setIsStreamVisible] = useState(false)
  const [step, setStep] = useState(0)
  const [tabIndex, setTabIndex] = useState('1')
  const [podcastDescription, setPodcastDescription] = useState({
    description: '',
    plainText: ''
  })
  const [sampleAudioUrl, setSampleAudioUrl] = useState({ link: '', type: '' })
  const [IsPaused, setIsPaused] = useState(true)
  const [voiceList, setVoiceList] = useState([{ name: '', voice_id: '' }])
  const [musicList, setMusicList] = useState([{ filename: '', id: '' }])
  const [allEpisode, setEpisode] = useState([
    {
      content: [],
      speakers: [],
      cover: { id: '', link: '', file_size: '', filename: '' },
      cover_id: '',
      title: '',
      id: '',
      link: '',
      filename: '',
      description: '',
      planeTextDescription: '',
      music_id: ''
    }
  ])
  const [formValues, setFormValues] = useState({
    cover: { id: '', link: '', file_size: '', filename: '' },
    cover_id: '',
    topic: '',
    title: '',
    description: '',
    speakers: null,
    episodes: null,
    length: '',
    host: '',
    tone: '',
    music_id: '',
    files: [],
    guests: ['kismat']
  })
  const [attachedData, setAttachedData] = useState({
    filenames: [],
    attachmentIds: []
  })
  const [speakerList, setSpeakerList] = useState([])
  const [isEdit, setIsEdit] = useState({
    status: false,
    context: '',
    index: null,
    contentIndex: null
  })
  const [isSaving, setIsSaving] = useState(false)
  const [createModal, setCreateModal] = useState(false)
  const [detailModal, setDetailModal] = useState(false)
  const [isGenerating, setIsGenerating] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [isMusicUploaded, setMusicUploaded] = useState(false)
  const [openMusicModal, setMusicModal] = useState({
    open: false,
    isUploading: false,
    index: '',
    id: '',
    link: ''
  })
  const [openAudioModal, setOpenAudioModal] = useState({
    open: false,
    id: '',
    index: '',
    speakerIndex: '',
    src: ''
  })
  const [voiceData, setVoiceData] = useState({
    open: false,
    id: '',
    audio_url: '',
    name: ''
  })
  const [selectedAudio, setSelectedAudio] = useState({
    id: '',
    audio_url: '',
    name: ''
  })
  const [isVoiceLoading, setIsVoiceLoading] = useState(false)
  const [isVoiceDeleating, setIsVoiceDeleting] = useState({
    status: false,
    voice_id: ''
  })
  const [isChatVisible, setIsChatVisible] = useState(false)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [chatMessages, setChatMessages] = useState([])
  const [chatInput, setChatInput] = useState('')
  const [isChatGenerating, setIsChatGenerating] = useState(false)
  const [chatStreamedText, setChatStreamedText] = useState('')
  const chatBottomRef = useRef(null)
  const [streamHistory, setStreamHistory] = useState([])
  const [selectedStreamIndex, setSelectedStreamIndex] = useState(null)

  useEffect(() => {
    if (chatBottomRef.current) {
      chatBottomRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [chatMessages, chatStreamedText, isChatVisible])

  const {
    getFieldDecorator,
    validateFields,
    getFieldsValue,
    setFieldsValue
  } = form
  useEffect(() => {
    getAllVoice()
    getAllMusic()
    const el = scrollContainerRef.current
    if (!el) return

    const handleScroll = () => {
      const isNearBottom =
        el.scrollHeight - el.scrollTop - el.clientHeight <= 50
      if (!isNearBottom) {
        el.dataset.sticky = 'false' // stop auto-scroll
      }
    }

    el.addEventListener('scroll', handleScroll)
    return () => el.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    let interval = null

    if (!streamedText) {
      interval = setInterval(() => {
        setDotCount(prev => (prev + 1) % 4)
      }, 500)
    }

    if (isStreaming) {
      const el = scrollContainerRef.current
      if (el) {
        const isNearBottom =
          el.scrollHeight - el.scrollTop - el.clientHeight <= 50

        if (isNearBottom) {
          el.dataset.sticky = 'true'
        }

        if (el.dataset.sticky === 'true') {
          el.scrollTo({
            top: el.scrollHeight,
            behavior: 'smooth'
          })
        }
      }
    }

    return () => {
      if (interval) clearInterval(interval)
    }
  }, [streamedText, isStreaming])



  useEffect(() => {
    setFieldsValue({
      files: attachedData.attachmentIds
    })
  }, [attachedData.attachmentIds])

  useEffect(() => {
    if (audioRef.current && sampleAudioUrl.link) {
      audioRef.current.pause()
      if (!IsPaused && sampleAudioUrl.type === 'music') {
        audioRef.current.load()
        audioRef.current.play().catch(error => {
          console.error('Audio playback failed', error)
        })
      } else if (sampleAudioUrl.type === 'voice') {
        setIsPaused(true)
        audioRef.current.load()
        audioRef.current.play().catch(error => {
          console.error('Audio playback failed', error)
        })
      }
      const handleEnded = () => {
        audioRef.current.currentTime = 0
        if (sampleAudioUrl.type === 'music') {
          setIsPaused(true)
        } else {
          setSampleAudioUrl({ ...sampleAudioUrl, link: '' })
        }
      }
      audioRef.current.addEventListener('ended', handleEnded)
      return () => {
        audioRef.current.removeEventListener('ended', handleEnded)
      }
    }
  }, [sampleAudioUrl, IsPaused])

  const getAllVoice = async () => {
    const res = await dispatch(actions.podcast.getAllVoices())
    if (res.data && res.status >= 200 && res.status <= 300) {
      if (res.data.voices) {
        const sortedVoices = res.data.voices.sort((a, b) => {
          const getGenderRank = voice => {
            // Check if labels exists and is not null/empty
            if (
              !voice.labels ||
              typeof voice.labels !== 'object' ||
              Object.keys(voice.labels).length === 0
            ) {
              return 0 // Top rank for voices without labels
            }

            // Check if gender exists in labels
            if (
              voice.labels.gender &&
              typeof voice.labels.gender === 'string'
            ) {
              const gender = voice.labels.gender.toLowerCase()
              if (gender === 'female') return 1
              if (gender === 'male') return 2
            }

            return 3 // Default rank for unknown gender or missing gender
          }

          const genderA = getGenderRank(a)
          const genderB = getGenderRank(b)

          if (genderA !== genderB) return genderA - genderB

          return a.name.localeCompare(b.name)
        })
        setVoiceList(sortedVoices)
      }
    }
  }

  const getAllMusic = async () => {
    const res = await dispatch(actions.podcast.getAllMusic())
    if (res.data && res.status <= 300 && res.status >= 200) {
      if (res.data.rows.length > 0) {
        setMusicList(res.data.rows)
      } else {
        message.error('Music list is currently empty!')
      }
    }
  }

  const previous = () => {
    setFieldsValue({
      cover_id: formValues.cover_id,
      title: formValues.title,
      description: formValues.description,
      episodes: formValues.episodes,
      speakers: formValues.speakers,
      guests: formValues.guests,
      host: formValues.host,
      length: formValues.length,
      tone: formValues.tone,
      files: attachedData.attachmentIds
    })
    let speakerList = []
    formValues.guests.forEach(name => {
      speakerList.push({ speaker_name: name })
    })
    setSpeakerList(speakerList)
    setStep(0)
    setEpisode(prevEpisodes => {
      const newEpisodes = prevEpisodes.map(episode => ({
        ...episode,
        id: '',
        link: '',
        filename: ''
      }))
      return newEpisodes
    })

    // Always show stream modal with chat when returning from step 1
    if (streamedText) {
      setIsStreaming(false) // Ensure streaming is not active
      setIsStreamVisible(true)
      // Open chat after a small delay to ensure modal is rendered
      setTimeout(() => {
        setIsChatVisible(true)
      }, 400)
    }
  }
  const checkNewContentStatus = async episodeList => {
    try {
      if (!episodeList) {
        throw new Error('Could not fetch content!')
      }
      let tempEpishodes = []
      episodeList.forEach(item => {
        tempEpishodes.push({
          content: item.content,
          speakers: item.speakers,
          title: item.title,
          description: podcastDescription.description,
          planeTextDescription: podcastDescription.plainText,
          id: '',
          link: '',
          filename: '',
          cover: {
            id: selectedCover.id,
            link: selectedCover.link,
            file_size: selectedCover.file_size,
            filename: selectedCover.filename
          },
          cover_id: selectedCover.id
        })
      })
      setEpisode(tempEpishodes)
      setStep(1)
    } catch (error) {
      message.error(error.message)
    } finally {
      setIsGenerating(false)
    }
  }

  // Stream history management functions
  const saveStreamToHistory = (streamText, source = 'initial', jsonData = null) => {
    const newStreamEntry = {
      streamText,
      timestamp: Date.now(),
      source, // 'initial' or 'chat'
      index: streamHistory.length,
      jsonData // Store episode JSON for restoration
    }

    setStreamHistory(prev => [...prev, newStreamEntry])
    setSelectedStreamIndex(streamHistory.length)

    // Add stream log message to chat
    const streamLogMessage = {
      role: 'stream_log',
      content: source === 'initial'
        ? 'Initial podcast script generated'
        : 'Podcast script updated',
      streamText,
      timestamp: newStreamEntry.timestamp,
      source,
      index: streamHistory.length,
      jsonData
    }

    setChatMessages(prev => [...prev, streamLogMessage])
  }

  const handleStreamLogClick = (streamIndex) => {
    const selectedStream = streamHistory[streamIndex]
    if (selectedStream) {
      const formattedText = selectedStream.streamText.replace(/\\n/g, '\n')
      setStreamedText(formattedText)
      setSelectedStreamIndex(streamIndex)
      // Restore JSON data if available
      if (selectedStream.jsonData) {
        checkNewContentStatus(selectedStream.jsonData)
      }
      message.success(`Reverted to stream version ${streamIndex + 1}`)
    }
  }

  const clearStreamHistory = () => {
    setStreamHistory([])
    setSelectedStreamIndex(null)
    setChatMessages([])
  }

  const handleChatSubmit = async () => {
    if (!chatInput.trim()) return

    const userMsg = chatInput
    setChatMessages(prev => [...prev, { role: 'user', content: userMsg }])
    setChatInput('')
    setIsChatGenerating(true)
    setChatStreamedText('')

    const payload = {
      type: 'chat',
      podcast_script: streamedText,
      speakers: formValues.guests || [],
      user_message: userMsg
    }

    try {
      const handleChunk = chunk => {
        setChatStreamedText(prev => prev + chunk)
      }

      const handleFinish = result => {
        setChatMessages(prev => [
          ...prev,
          { role: 'assistant', content: result.fullText }
        ])
        setChatStreamedText('')
        setIsChatGenerating(false)

        if (result.json) {
          if (result?.json?.updated_script) {
            const formattedScript = result.json.updated_script.replace(/\\n/g, '\n')
            setStreamedText(formattedScript)
            saveStreamToHistory(formattedScript, 'chat', result?.json?.json_output)
          }
          if (result?.json?.json_output) {
            checkNewContentStatus(result?.json?.json_output)
          }
        }
      }

      await api.podcast.chatPodcastGenerate(payload, handleChunk, handleFinish)
    } catch (error) {
      message.error('Failed to generate chat response!', error)
      setIsChatGenerating(false)
    }
  }

  const generateContent = async () => {
    validateFields()
      .then(async values => {
        setIsGenerating(true)
        setStreamedText('')
        // Clear stream history when starting fresh generation
        clearStreamHistory()
        let payload = {
          type:
            contentSource === 'document'
              ? 'file'
              : contentSource === 'organization'
                ? 'organization'
                : 'topic',
          ...((contentSource === 'internet' ||
            contentSource === 'organization') && {
            title: values.topic
          }),
          podcast_name: roomName,
          ...(contentSource === 'organization' && {
            org_id: activeOrganizationId.toString()
          }),
          ...(contentSource !== 'organization' && {
            is_public: false
          }),
          episodes: parseInt(values.episodes),
          previous_podcast: Array.isArray(previousPodcast)
            ? previousPodcast
              .map(f => f.custom_data && f.custom_data.script_file_path)
              .filter(x => x)
            : [],
          speakers: values.guests,
          tone: values.tone,
          description: podcastDescription.plainText,
          length: values.length,
          ...(contentSource === 'document' && {
            file_path: attachedData.filenames.map(f => f.path)
          })
        }
        try {
          setIsStreamVisible(true)
          setIsStreaming(true)
          const handleChunk = chunk => {
            setStreamedText(prev => prev + chunk)
          }

          const handleFinish = result => {
            setIsStreaming(false)
            setFormValues({
              ...formValues,
              topic: values.topic,
              title: roomName,
              description: description,
              episodes: values.episodes || 1,
              speakers: values.speakers,
              guests: values.guests,
              host: values.host,
              length: values.length,
              tone: values.tone
            })
            // Save initial stream to history with JSON data
            saveStreamToHistory(result.fullText, 'initial', result.json)
            checkNewContentStatus(result.json)

            // Open chat with delay to ensure layout renders correctly
            setTimeout(() => {
              setIsChatVisible(true)
            }, 700)
          }

          await api.podcast.newPodcastGenerate(
            payload,
            handleChunk,
            handleFinish
          )
        } catch (error) {
          message.error('Failed to generate podcast content!', error)
          setIsStreamVisible(false)
          setIsGenerating(false)
          setIsStreaming(false)
        }
      })
      .catch(err => {
        message.error('Please fill all the required fields!')
      })
  }

  const setCoverImage = (cover, index) => {
    setFieldsValue({ [`cover_id${index}`]: cover.id })
    setEpisode(prevEpisodes => {
      const newEpisodes = [...prevEpisodes]
      newEpisodes[index] = {
        ...newEpisodes[index],
        cover: cover,
        cover_id: cover.id
      }
      return newEpisodes
    })
  }
  const changeEpisodeTitle = useCallback(
    debounce((title, index) => {
      setEpisode(prevEpisodes => {
        const newEpisodes = [...prevEpisodes]
        newEpisodes[index] = {
          ...newEpisodes[index],
          title: title
        }
        return newEpisodes
      })
    }, 500),
    []
  )
  const setEditorDescription = useCallback(
    debounce((editorText, planeText, index) => {
      setEpisode(prevEpisodes => {
        const newEpisodes = [...prevEpisodes]
        newEpisodes[index] = {
          ...newEpisodes[index],
          description: editorText,
          planeTextDescription: planeText
        }
        return newEpisodes
      })
    }, 500),
    []
  )
  // const setEditorPodcastDescription = useCallback(
  //   debounce(editorText => {
  //     const plainText = editorText.replace(/<\/?[^>]+(>|$)/g, '')
  //     const decodeEntities = str => {
  //       const textarea = document.createElement('textarea')
  //       textarea.innerHTML = str
  //       return textarea.value
  //     }
  //     const decodedText = decodeEntities(plainText)
  //     if (!decodedText) {
  //       setFieldsValue({ description: '' })
  //     }
  //     setPodcastDescription({
  //       description: editorText,
  //       plainText: decodedText
  //     })
  //   }, 500),
  //   []
  // )
  const setEditorPodcastDescription = editorText => {
    setFieldsValue({ description: editorText.target.value })
    setPodcastDescription({
      description: editorText.target.value,
      plainText: editorText.target.value
    })
  }
  const changeHostName = e => {
    let name = e.target.value
    setSpeakerList(prevSpeakerList => {
      const updatedSpeakerList = [...prevSpeakerList]
      if (updatedSpeakerList.length > 0) {
        updatedSpeakerList[0] = {
          ...updatedSpeakerList[0],
          speaker_name: name
        }
      }
      return updatedSpeakerList
    })
    setFieldsValue({ 'guests[0]': name })
  }
  const handleChangeSpeaker = number => {
    let hostname = getFieldsValue().host
    let speakerList = []
    for (let i = 1; i <= number; i++) {
      if (i === 1) {
        speakerList.push({ speaker_name: hostname })
      } else {
        speakerList.push({ speaker_name: '' })
      }
    }
    setSpeakerList(speakerList)
  }
  const episodeChanage = index => {
    setTabIndex(index)
    setIsPaused(true)
  }
  const listenSample = (speaker, index, speakerIndex) => {
    let voice = { preview_url: '' }
    voice = voiceList.find(
      el => el.voice_id === getFieldsValue()[`voice_e${index}_s${speakerIndex}`]
    )
    if (voice.preview_url) {
      setSampleAudioUrl({ link: voice.preview_url, type: 'voice' })
    } else {
      message.warn('There is audio sample for this voice!')
    }
  }
  const listenMusic = (status, index) => {
    let music_id = getFieldsValue()[`music_id${index}`]
    let music = musicList.find(el => el.id === music_id)
    if (!music) {
      message.error('Please select music!')
      return
    } else if (music.link && music.link !== sampleAudioUrl) {
      setSampleAudioUrl({ link: music.link, type: 'music' })
    }
    setIsPaused(status)
  }
  const updateContext = (index, contentIndex) => {
    setEpisode(prevEpisodes => {
      const newEpisodes = [...prevEpisodes]
      newEpisodes[index] = {
        ...newEpisodes[index],
        id: '',
        link: '',
        filename: '',
        content: prevEpisodes[index].content.map((item, i) =>
          i === contentIndex ? { ...item, context: isEdit.context } : item
        )
      }
      return newEpisodes
    })
    setIsEdit({ index: -1, contentIndex: -1, status: false, contents: '' })
  }
  const handleInputChange = e => {
    const value = e.target.value
    setIsEdit({ ...isEdit, context: value })
  }
  const generateAudio = async index => {
    if (!allEpisode[index].planeTextDescription) {
      setFieldsValue({ [`description${index}`]: '' })
      message.error('Please fill all the required fields!')
      return
    }
    try {
      await validateFields()
    } catch (error) {
      message.error('Please fill all the required fields!')
      return
    }
    setIsPaused(true)
    let voices = []
    let speakers = []
    allEpisode.forEach((el, i) => {
      if (i === index) {
        el.speakers.forEach((speaker, speakerIndex) => {
          speakers.push(speaker)
          voices.push({
            [speaker]: getFieldsValue()[`voice_e${index}_s${speakerIndex}`]
          })
        })
      }
    })
    const objectVoices = voices.reduce((acc, obj) => {
      return { ...acc, ...obj }
    }, {})
    let payload = {
      title: allEpisode[index].title,
      speakers: speakers,
      voices: objectVoices,
      content: allEpisode[index].content,
      ...(getFieldsValue()[`music_id${index}`] && {
        music_id: getFieldsValue()[`music_id${index}`]
      })
    }
    setIsGenerating(true)
    setEpisode(prevEpisodes => {
      const newEpisodes = [...prevEpisodes]
      newEpisodes[index] = {
        ...newEpisodes[index],
        id: '',
        link: '',
        filename: ''
      }
      return newEpisodes
    })
    try {
      const res = await dispatch(actions.podcast.generatePodcastAudio(payload))
      if (res.data && res.status <= 300 && res.status >= 200 && res.data.id) {
        checkPodcastStatus(res.data.id, index)
      } else {
        message.error('Failed to generate audio!')
        setIsGenerating(false)
      }
    } catch (error) {
      message.error('Failed to generate audio!')
      setIsGenerating(false)
    }
  }
  const checkPodcastStatus = async (id, index) => {
    const res = await dispatch(actions.podcast.checkPodcastStatus(id))
    if (res.data && res.status <= 300 && res.status >= 200) {
      if (res.data.link) {
        setEpisode(prevEpisodes => {
          const newEpisodes = [...prevEpisodes]
          newEpisodes[index] = {
            ...newEpisodes[index],
            id: res.data.id,
            link: res.data.link,
            filename: res.data.filename
          }
          return newEpisodes
        })

        setIsGenerating(false)
      } else {
        setTimeout(() => {
          checkPodcastStatus(id, index)
        }, 10000)
      }
    } else {
      setIsGenerating(false)
      message.error('Failed to generate audio!')
    }
  }
  const createPodcastEpisodes = async () => {
    setIsSaving(true)
    onFinish(allEpisode)
    setTimeout(() => {
      setIsSaving(false)
    }, 300)
  }
  const createVoice = async () => {
    setIsVoiceLoading(true)
    let payload = {
      audio_url: voiceData.audio_url,
      name: voiceData.name
    }
    const res = await dispatch(actions.podcast.createVoice(payload))

    if (res.data && res.status <= 300 && res.status >= 200) {
      let tempVoice = [...voiceList]
      tempVoice.push(res.data)
      setVoiceList(tempVoice)
      setIsVoiceLoading(false)
      setFieldsValue({
        ['voice_e' +
          openAudioModal.index +
          '_s' +
          openAudioModal.speakerIndex]: res.data.voice_id
      })
      setVoiceData({
        open: false,
        id: '',
        audio_url: '',
        name: ''
      })
      setOpenAudioModal({ ...openAudioModal, open: false })
      clearUploadList()
    } else {
      clearUploadList()
      setIsVoiceLoading(false)
      message.error(t('v5:failed_to_create_voicce'))
    }
  }
  const deleteVoice = async (voice_id, eIndex, sIndex) => {
    setIsVoiceDeleting({ voice_id: voice_id, status: true })
    let payload = {
      voice_id: voice_id
    }

    try {
      const res = await dispatch(actions.podcast.deleteVoice(payload))
      if (
        res.data &&
        res.status >= 200 &&
        res.status < 300 &&
        !res.data.error
      ) {
        let tempVoice = voiceList.filter(el => el.voice_id !== voice_id)
        setVoiceList(tempVoice)
        if (getFieldsValue()[`voice_e${eIndex}_s${sIndex}`] === voice_id) {
          setFieldsValue({
            ['voice_e' + eIndex + '_s' + sIndex]: tempVoice[0].voice_id
          })
        }
        message.success('Voice deleted successfully')
        setIsVoiceDeleting({ voice_id: '', status: false })
      } else {
        throw res.data.error || 'Failed to delete voice!'
      }
    } catch (error) {
      message.error(error)
      setIsVoiceDeleting({ voice_id: '', status: false })
    }
  }
  const onShowCreateModal = () => {
    setCreateModal(true)
    setOpenAudioModal({ ...openAudioModal, status: false })
  }
  const onShowDetailModal = src => {
    setCreateModal(false)
    setDetailModal(true)
    setOpenAudioModal({ ...openAudioModal, status: false, src: src })
  }
  const getSelectedFile = files => {
    let file = files[0]
    let filename = file.filename
      ? file.filename
        .replace(/\.mp3$/gi, '')
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase())
      : 'Test Voice'
    setSelectedAudio({ id: file.id, audio_url: file.link, name: filename })
  }

  const handleInsertData = ({ rows: privateData }, publicMedia, orgMedia) => {
    let tempData = privateData
    if (publicMedia) {
      const { rows: publicData } = publicMedia
      tempData = [...privateData, ...publicData]
    }

    if (orgMedia) {
      const { rows: orgData } = orgMedia
      tempData = [...privateData, ...orgData]
    }

    const selectedItem = _.head(tempData.filter(value => value.isSelected))
    let filename = selectedItem.filename
      .replace(/\.mp3$/gi, '')
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase())
    setSelectedAudio({
      id: selectedItem.id,
      audio_url: selectedItem.link,
      name: filename
    })
  }
  const handleFileUpload = files => {
    let file = files[0]
    if (!file) {
      return
    }
    setOpenAudioModal({ ...openAudioModal, status: true })
    setDetailModal(false)
    let filename = file.filename
      .replace(/\.mp3$/gi, '')
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase())
    setVoiceData({
      open: true,
      id: file.id,
      audio_url: file.link,
      name: filename
    })
  }
  const selectMusic = id => {
    let music = musicList.find(el => el.id === id)
    setSampleAudioUrl({ link: music ? music.link : '', type: 'music' })
    setIsPaused(false)
  }
  const createMusic = () => {
    setFieldsValue({
      ['music_id' + openMusicModal.index]: openMusicModal.id
    })
    // play the music
    setSampleAudioUrl({ link: openMusicModal.link, type: 'music' })
    setIsPaused(false)
    setMusicModal({
      ...openMusicModal,
      open: false
    })
    setMusicUploaded(false)
  }

  const onDropFile = async dropped => {
    let file = dropped[0]
    clearUploadList()
    if (!file || isMusicUploaded) {
      return
    }
    const maxSize = 100 * 1024 * 1024
    if (file.size > maxSize) {
      message.error('File size must be lower then 100 MB!')
      return
    }
    if (file.type !== 'audio/mpeg') {
      message.error('Invalid file format (only accepts .mp3)!')
      return
    }
    setMusicModal({ ...openMusicModal, isUploading: true })
    let res = await upload(file)
    let formData = {
      id: res.id,
      filename: res.filename
        .replace(/\.mp3$/gi, '')
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase()),
      keywords: 'music',
      description: 'music',
      title: res.title,
      category: 'music'
    }
    await api.library.updateMedia(formData.id, formData)
    let tempMusic = [...musicList]
    tempMusic.push(formData)
    setMusicList(tempMusic)

    clearUploadList()
    setMusicUploaded(true)
    setMusicModal({
      ...openMusicModal,
      isUploading: false,
      id: res.id,
      link: res.link
    })
  }
  const handleChangeSource = e => {
    setContentSource(e.target.value)
    setAttachedData({ filenames: [], attachmentIds: [] })
  }
  const onFiles = filesArray => {
    if (_.isEmpty(filesArray) && _.isEmpty(attachedData.attachmentIds)) return
    const filesById = filesArray.map(item => item.id)
    filesById &&
      setAttachedData({
        ...attachedData,
        filenames: filesArray,
        attachmentIds: filesById
      })
  }

  return (
    <Modal
      title={t('v4:generate_podcast_audio')}
      visible={open}
      onCancel={close}
      maskClosable={false}
      footer={[
        step === 0 && (
          <Fragment>
            <Tooltip
              placement="left"
              title={t('v4:generate_uploaded_file_input_parameter')}
              arrow
            >
              <span>
                <Button
                  type="primary"
                  className="rounded"
                  loading={isGenerating}
                  onClick={generateContent}
                  disabled={isUploading}
                >
                  {t('v5:generate_text')}
                </Button>
              </span>
            </Tooltip>
          </Fragment>
        ),
        step === 1 && (
          <Fragment>
            <Tooltip
              placement="left"
              title={t('v4:go_backe_generation_state')}
              arrow
            >
              <span>
                <Button
                  type="primary"
                  className="rounded"
                  onClick={() => {
                    previous()
                  }}
                  disabled={isGenerating}
                >
                  <LeftOutlined /> {t('v4:go_back')}
                </Button>
              </span>
            </Tooltip>
            &nbsp;
            <Tooltip
              placement="left"
              title={
                allEpisode.every(
                  episode => episode.link && episode.link.trim() !== ''
                )
                  ? t('v4:create_ai_powered_podcast')
                  : t('v4:generate_voice_for_all_podcast')
              }
              arrow
            >
              <span>
                <Button
                  type="primary"
                  className="rounded"
                  loading={isSaving}
                  disabled={
                    !allEpisode.every(
                      episode => episode.link && episode.link.trim() !== ''
                    )
                  }
                  onClick={createPodcastEpisodes}
                >
                  {t('v4:create_podcast_episode')}
                </Button>
              </span>
            </Tooltip>
          </Fragment>
        )
      ]}
      centered
      width="85vw"
      className="full-width-modal"
    >
      <audio ref={audioRef} src={sampleAudioUrl.link} autoPlay />
      <Modal
        className="custom-ant-modal insert-audio-detail"
        visible={detailModal}
        onCancel={() => {
          setDetailModal(false)
        }}
        width={'40%'}
        footer={false}
      >
        <AddDetailAudio
          handleFileUpload={handleFileUpload}
          getSelectedFile={getSelectedFile}
          src={openAudioModal.src}
          isFromCreateAudio
          onHideDetailModal={() => {
            setDetailModal(false)
          }}
          t={t}
        />
      </Modal>
      <Modal
        className="custom-ant-modal"
        title={<AudioModalTitleIcon t={t} isShowCreateAudioModal={true} />}
        visible={createModal}
        onCancel={() => {
          setCreateModal(false)
          setOpenAudioModal({
            id: '',
            open: true,
            src: '',
            index: '',
            speakerIndex: ''
          })
        }}
        footer={false}
        width={'88%'}
      >
        <CreateAudio onShowDetailModal={onShowDetailModal} t={t} />
      </Modal>
      <Modal
        title={<AudioIcon t={t} />}
        className="custom-ant-modal"
        onCancel={() => {
          setOpenAudioModal({
            id: '',
            open: false,
            src: '',
            index: '',
            speakerIndex: ''
          })
        }}
        visible={openAudioModal.open}
        width={'85%'}
        footer={
          <FooterActions
            t={t}
            isDisabled={!selectedAudio.audio_url}
            loading={isVoiceLoading}
            title={t('buttons:create')}
            onClickCancel={() => {
              setOpenAudioModal({
                id: '',
                open: false,
                src: '',
                index: '',
                speakerIndex: ''
              })
            }}
            onClickTitle={() => setVoiceData({ ...selectedAudio, open: true })}
          />
        }
      >
        <Audio
          isPodcast
          isPageBuilder
          onShowCreateModal={onShowCreateModal}
          getSelectedFile={getSelectedFile}
          handleInsertData={handleInsertData}
          src={openAudioModal.src}
        />
      </Modal>
      <Modal
        title="Create Voice"
        visible={voiceData.open}
        onCancel={() => setVoiceData({ ...voiceData, open: false })}
        footer={null}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label={t('v4:voice_name')}
            rules={[{ required: true, message: t('v4:input_custom_name') }]}
          >
            <Input
              defaultValue={voiceData.name}
              placeholder={t('v4:enter_custom_name')}
              onChange={e => {
                let name = e.target.value
                setVoiceData({ ...voiceData, name: name })
              }}
            />
          </Form.Item>
          <Form.Item>
            <Row type="flex" justify="end">
              <Col>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isVoiceLoading}
                  disabled={!voiceData.name}
                  onClick={createVoice}
                >
                  Create Voice
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        className="custom-ant-modal"
        title={<AudioIcon t={t} />}
        onCancel={() => {
          setMusicModal({
            id: '',
            open: false,
            index: '',
            isUploading: false,
            link: ''
          })
        }}
        visible={openMusicModal.open}
        width={300}
        footer={
          <FooterActions
            t={t}
            isDisabled={!openMusicModal.link && !openMusicModal.isUploading}
            loading={openMusicModal.isUploading}
            title={t('buttons:create')}
            onClickCancel={() => {
              setMusicUploaded(false)
              setMusicModal({
                id: '',
                open: false,
                index: '',
                isUploading: false,
                link: ''
              })
            }}
            onClickTitle={createMusic}
          />
        }
      >
        <div className="dropzone-body">
          <Dropzone
            accept={'.mp3'}
            multiple={false}
            onDrop={onDropFile}
            activeStyle={{
              height: '100%',
              width: '100%'
            }}
          >
            {() => (
              <div className={'music-dropzone'}>
                <div className="music-dropzone__text-wrapper">
                  {isMusicUploaded ? (
                    <>
                      <Progress type="circle" percent={100} />
                      <br />
                      <br />
                      <p>{t('v4:upload_complete')}</p>
                    </>
                  ) : openMusicModal.isUploading ? (
                    <>
                      <Progress
                        type="circle"
                        percent={
                          library &&
                          library.uploadProgress[0] &&
                          library.uploadProgress[0].percent
                        }
                      />
                      <br />
                      <br />
                      <p>{t('v4:uploading_in_progress')}</p>
                    </>
                  ) : (
                    <>
                      <img src={deactiveSoundIcon} alt="" />
                      <p>{t('v4:drop_files')}</p>
                      <p>{t('media:or')}</p>
                      <Button>{t('v4:import_music_from_computer')}</Button>
                    </>
                  )}
                </div>
              </div>
            )}
          </Dropzone>
        </div>
      </Modal>
      <Modal
        title={
          <>
            {t('v4:podcast_stream_content')}
            {!isGenerating ? (
              <>
                &nbsp; <CheckCircleTwoTone twoToneColor="#52c41a" />
              </>
            ) : (
              <>
                &nbsp; <Spin indicator={<LoadingOutlined spin />} />
              </>
            )}
          </>
        }
        visible={IsStreamVisible}
        onCancel={() => {
          setIsStreamVisible(false)
        }}
        closable={false}
        footer={
          <div
            style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}
          >
            <Button
              type="primary"
              shape="round"
              size="default"
              loading={isGenerating}
              onClick={() => {
                if (chatMessages.length > 0 && !isGenerating) {
                  // Close chat and proceed to next step
                  setIsChatVisible(false)
                  setTimeout(() => {
                    setIsStreamVisible(false)
                    setStep(1)
                  }, 100)
                } else {
                  // Just close modal
                  setIsStreamVisible(false)
                }
              }}
              className="ant-btn rounded"
            >
              {!isGenerating && step === 0 && chatMessages.length === 0
                ? t('buttons:close')
                : t('v4:btn_proceed')}
            </Button>
          </div>
        }
        centered
        width="85vw"
        className="full-width-modal"
      >
        <div style={{ display: 'flex', gap: '16px', overflow: 'hidden', position: 'relative', height: '500px' }}>
          <div
            ref={scrollContainerRef}
            style={{
              width: isChatVisible ? 'calc(100% - 416px)' : '100%',
              whiteSpace: 'pre-wrap',
              minHeight: '500px',
              maxHeight: '500px',
              overflowY: 'auto',
              transition: 'width 0.3s cubic-bezier(0.23, 1, 0.32, 1)'
            }}
          >
            {streamedText ||
              `Starting content stream, please wait${'.'.repeat(dotCount)}`}
          </div>

          {!isGenerating && (
            <Tooltip title={isChatVisible || isTransitioning ? "" : "Podcast Assistant"} placement="left">
              <Button
                type="default"
                shape="circle"
                onClick={() => {
                  setIsTransitioning(true)
                  setIsChatVisible(!isChatVisible)
                  setTimeout(() => setIsTransitioning(false), 300)
                }}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: `translate(${isChatVisible ? '-400px' : '0'}, -50%)`,
                  zIndex: 20,
                  transition: 'all 0.3s cubic-bezier(0.23, 1, 0.32, 1)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  border: '1px solid #f0f0f0',
                  background: '#fff',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {isChatVisible ? (
                  <DoubleRightOutlined style={{ fontSize: '16px', color: '#595959' }} />
                ) : (
                  <DoubleLeftOutlined style={{ fontSize: '16px', color: '#595959' }} />
                )}
              </Button>
            </Tooltip>
          )}
          <div
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              bottom: 0,
              width: '400px',
              transform: `translateX(${isChatVisible ? '0' : '100%'})`,
              transition: 'transform 0.3s cubic-bezier(0.23, 1, 0.32, 1)',
              borderLeft: '1px solid #f0f0f0',
              display: 'flex',
              flexDirection: 'column',
              background: '#fff',
              zIndex: 10,
              boxShadow: isChatVisible ? '-4px 0 16px rgba(0,0,0,0.08)' : 'none',
              overflow: 'hidden'
            }}
          >
            <Tooltip title="Talk to the Podcast Assistant to refine your content" placement="right">
              <div
                style={{
                  padding: '16px',
                  borderBottom: '1px solid #f0f0f0',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'help'
                }}
              >
                <MessageOutlined /> Podcast Assistant
              </div>
            </Tooltip>
            <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
              {chatMessages.length === 0 && !isChatGenerating && (
                <div
                  style={{
                    color: 'rgba(0,0,0,0.45)',
                    textAlign: 'center',
                    marginTop: '20px'
                  }}
                >
                  How can I help you regarding this podcast?
                </div>
              )}
              {chatMessages.map((msg, idx) => (
                <div
                  key={idx}
                  style={{
                    marginBottom: '12px',
                    textAlign: msg.role === 'user' ? 'right' : 'left'
                  }}
                >
                  {msg.role === 'stream_log' ? (
                    <div
                      onClick={() => handleStreamLogClick(msg.index)}
                      style={{
                        display: 'inline-block',
                        padding: '10px 14px',
                        borderRadius: '8px',
                        background: selectedStreamIndex === msg.index
                          ? '#e6f7ff'
                          : '#fafafa',
                        color: 'rgba(0,0,0,0.85)',
                        maxWidth: '80%',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        border: selectedStreamIndex === msg.index
                          ? '2px solid #1890ff'
                          : '1px solid #d9d9d9',
                        textAlign: 'left'
                      }}
                      onMouseEnter={(e) => {
                        if (selectedStreamIndex !== msg.index) {
                          e.currentTarget.style.borderColor = '#40a9ff'
                          e.currentTarget.style.background = '#f0f5ff'
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (selectedStreamIndex !== msg.index) {
                          e.currentTarget.style.borderColor = '#d9d9d9'
                          e.currentTarget.style.background = '#fafafa'
                        }
                      }}
                    >
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '4px'
                      }}>
                        <CheckCircleTwoTone twoToneColor={selectedStreamIndex === msg.index ? '#1890ff' : '#52c41a'} />
                        <strong style={{ color: selectedStreamIndex === msg.index ? '#1890ff' : 'rgba(0,0,0,0.85)' }}>
                          {msg.content}
                        </strong>
                      </div>
                      <div style={{
                        fontSize: '12px',
                        color: 'rgba(0,0,0,0.45)',
                        marginTop: '4px'
                      }}>
                        {new Date(msg.timestamp).toLocaleTimeString()} •
                        {msg.source === 'initial' ? ' Initial Generation' : ' Chat Update'}
                        {selectedStreamIndex !== msg.index && ' • Click to restore'}
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'inline-block',
                        padding: '8px 12px',
                        borderRadius: '12px',
                        background: msg.role === 'user' ? '#1890ff' : '#f0f2f5',
                        color: msg.role === 'user' ? '#fff' : 'rgba(0,0,0,0.85)',
                        maxWidth: '80%',
                        wordBreak: 'break-word',
                        textAlign: 'left'
                      }}
                    >
                      <pre
                        style={{
                          margin: 0,
                          whiteSpace: 'pre-wrap',
                          fontFamily: 'inherit'
                        }}
                      >
                        {msg.content}
                      </pre>
                    </div>
                  )}
                </div>
              ))}
              {isChatGenerating && (
                <div style={{ textAlign: 'left', marginBottom: '12px' }}>
                  <div
                    style={{
                      display: 'inline-block',
                      padding: '8px 12px',
                      borderRadius: '12px',
                      background: '#f0f2f5',
                      color: 'rgba(0,0,0,0.85)',
                      maxWidth: '80%',
                      wordBreak: 'break-word',
                      textAlign: 'left'
                    }}
                  >
                    <pre
                      style={{
                        margin: 0,
                        whiteSpace: 'pre-wrap',
                        fontFamily: 'inherit',
                        overflow: 'hidden'
                      }}
                    >
                      {chatStreamedText || (
                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Spin
                            indicator={<LoadingOutlined spin />}
                            size="small"
                          />
                          <span style={{ fontSize: '12px', color: 'rgba(0,0,0,0.45)' }}>loading...</span>
                        </span>
                      )}
                    </pre>
                  </div>
                </div>
              )}
              <div ref={chatBottomRef} />
            </div>
            <div
              style={{
                padding: '16px',
                borderTop: '1px solid #f0f0f0',
                display: 'flex',
                gap: '8px'
              }}
            >
              <Input
                value={chatInput}
                onChange={e => setChatInput(e.target.value)}
                onPressEnter={handleChatSubmit}
                placeholder="Type a message..."
                disabled={isChatGenerating}
                suffix={
                  <Tooltip title="Press Enter to send">
                    <EnterOutlined style={{ color: 'rgba(0,0,0,0.45)' }} />
                  </Tooltip>
                }
              />
            </div>
          </div>
        </div>
      </Modal>
      <div className="discussion-machine-main">
        <div className="discussion-machine-main-body">
          <Form layout="vertical">
            {step === 0 && (
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={16} lg={14}>
                  <Form.Item
                    required={false}
                    colon={false}
                    className="no_bottom_margin"
                  >
                    {getFieldDecorator('cover_id', {
                      initialValue: selectedCover.id,
                      rules: [
                        {
                          required: true,
                          message: t('v4:upload_podcast_cover')
                        }
                      ]
                    })(
                      <ImageSelect
                        isReadOnly
                        form={form}
                        label={t('v4:cover_picture')}
                        coverInput={selectedCover || null}
                      />
                    )}
                  </Form.Item>
                  <Form.Item
                    label={t('v4:room_name')}
                    colon={false}
                    required={false}
                  >
                    {getFieldDecorator('title', {
                      initialValue: roomName || '',
                      rules: [
                        {
                          required: true,
                          message: t('v4:enter_podcast_name')
                        }
                      ]
                    })(<Input readOnly />)}
                  </Form.Item>

                  <Row gutter={[8, 0]}>
                    <Col span={8}>
                      <Form.Item
                        label={t('v4:number_of_speaker')}
                        colon={false}
                        required={false}
                      >
                        {getFieldDecorator('speakers', {
                          initialValue: formValues.speakers || undefined,
                          rules: [
                            {
                              required: true,
                              message: t('v4:select_the_number_of_speaker')
                            }
                          ]
                        })(
                          <Select size="large" onChange={handleChangeSpeaker}>
                            <Option value={1}>1</Option>
                            <Option value={2}>2</Option>
                            <Option value={3}>3</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={t('v4:number_of_episode')}
                        colon={false}
                        required={false}
                      >
                        {getFieldDecorator('episodes', {
                          initialValue: formValues.episodes || 1,
                          rules: [
                            {
                              required: true,
                              message: t('v4:input_number_of_episode')
                            }
                          ]
                        })(
                          <Select size="large">
                            <Option value={1}>1</Option>
                            <Option value={2}>2</Option>
                            <Option value={3}>3</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={t('v4:podcast_length')}
                        colon={false}
                        required={false}
                      >
                        {getFieldDecorator('length', {
                          initialValue: formValues.length || '',
                          rules: [
                            {
                              required: true,
                              message: t('v4:select_the_podcast_length')
                            }
                          ]
                        })(
                          <Select size="large">
                            <Option value={'short'}>
                              {t('v4:short_podcast')}
                            </Option>
                            <Option value={'medium'}>
                              {t('v4:medium_podcast')}
                            </Option>
                            <Option value={'long'}>
                              {t('v4:long_podcast')}
                            </Option>
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    label={t('v4:name_of_host')}
                    colon={false}
                    required={false}
                  >
                    {getFieldDecorator('host', {
                      initialValue: formValues.host || '',
                      rules: [
                        {
                          required: true,
                          message: t('v4:enter_host_name')
                        },
                        {
                          pattern: /^[a-zA-Z0-9 .]*$/,
                          message: t(
                            'v4:only_letters_numbers_space_dot_allowed'
                          )
                        }
                      ]
                    })(<Input onChange={changeHostName} />)}
                  </Form.Item>
                  {speakerList.length >= 1 && (
                    <Form.Item
                      label={t('v4:guest_name')}
                      colon={false}
                      required={false}
                    >
                      {speakerList.map((speaker, i) => (
                        <Form.Item
                          key={i}
                          colon={false}
                          required={false}
                          style={{ marginBottom: 0 }} // Removed '!important' since it's not valid in inline styles
                        >
                          {getFieldDecorator(`guests[${i}]`, {
                            initialValue: speaker.speaker_name || '',
                            rules: [
                              {
                                required: true,
                                message: t('v4:enter_guest_name')
                              },
                              {
                                pattern: /^[a-zA-Z0-9 .]*$/,
                                message: t(
                                  'v4:only_letters_numbers_space_dot_allowed'
                                )
                              }
                            ]
                          })(
                            <Input
                              addonBefore={`No. ${i + 1} :`}
                              disabled={i === 0}
                            />
                          )}
                        </Form.Item>
                      ))}
                    </Form.Item>
                  )}

                  <Form.Item
                    label={t('v4:choose_speaker_tone')}
                    colon={false}
                    required={false}
                  >
                    {getFieldDecorator('tone', {
                      initialValue: formValues.tone || undefined,
                      rules: [
                        {
                          required: true,
                          message: t('v4:enter_speaker_tone')
                        }
                      ]
                    })(
                      <Select size="large">
                        <Option value="informal">{t('v4:informal')}</Option>
                        <Option value="formal">{t('v4:formal')}</Option>
                        <Option value="serious">{t('v4:serious')}</Option>
                        <Option value="light humor">
                          {t('v4:light_humor')}
                        </Option>
                        <Option value="casual">{t('v4:casual')}</Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8} lg={10}>
                  <Form.Item
                    label={t('v4:podcast_topic')}
                    colon={false}
                    required={false}
                  >
                    {getFieldDecorator('topic', {
                      initialValue: formValues.topic || '',
                      rules: [
                        {
                          required: true,
                          message: t('v4:enter_podcast_topic')
                        }
                      ]
                    })(<Input />)}
                  </Form.Item>

                  <Form.Item
                    label={t('v4:podcast_desc')}
                    colon={false}
                    required={false}
                  >
                    {getFieldDecorator('description', {
                      initialValue: podcastDescription.description || '',
                      rules: [
                        {
                          required: true,
                          message: t('v4:enter_podcast_desc')
                        }
                      ]
                    })(
                      <Input.TextArea
                        rows={4}
                        onChange={setEditorPodcastDescription}
                      />
                    )}
                  </Form.Item>
                  <Form.Item
                    label={t('v4:select_content_source')}
                    colon={false}
                    required={false}
                  >
                    {getFieldDecorator('source', {
                      initialValue: contentSource || 'internet'
                    })(
                      <Radio.Group onChange={handleChangeSource}>
                        <Radio
                          value="internet"
                          style={{
                            fontSize: '14px',
                            padding: '4px 0',
                            color: '#000'
                          }}
                        >
                          {t('v4:from_internet')}
                        </Radio>
                        <Radio
                          disabled={!activeOrganizationId}
                          value="organization"
                          style={{
                            fontSize: '14px',
                            padding: '4px 0',
                            color: '#000'
                          }}
                        >
                          {t('v3:my_organization')}
                        </Radio>
                        <Radio
                          value="document"
                          style={{
                            fontSize: '14px',
                            padding: '4px 0',
                            color: '#000'
                          }}
                        >
                          {t('v4:upload_pdf_internet')}
                        </Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8} lg={10}>
                  {contentSource === 'internet' && (
                    <Form.Item colon={false} required={false}>
                      <div
                        style={{
                          backgroundColor: '#f6f8fa',
                          borderLeft: '4px solid #0068ff',
                          padding: '12px 16px',
                          fontSize: '14px',
                          color: '#333',
                          borderRadius: '4px',
                          marginTop: '8px'
                        }}
                      >
                        <strong>{t('v4:note')}</strong>{' '}
                        {t(
                          'v4:podcast_content_will_be_automatically_generated'
                        )}
                      </div>
                    </Form.Item>
                  )}
                  {contentSource === 'document' && (
                    <Form.Item
                      colon={false}
                      required={false}
                      className="no_bottom_margin"
                    >
                      {getFieldDecorator('files', {
                        initialValue: attachedData.attachmentIds || undefined,
                        rules: [
                          {
                            required: true,
                            message: t('v4:upload_or_select_file')
                          }
                        ]
                      })(
                        <FileUpload
                          isTitle={'false'}
                          isMarginBottom={false}
                          files={attachedData.filenames}
                          onFiles={onFiles}
                          onUploadingChange={val => {
                            setIsUploading(val)
                          }}
                        />
                      )}
                    </Form.Item>
                  )}
                </Col>
              </Row>
            )}
            {step === 1 && (
              <Fragment>
                <Tabs
                  defaultActiveKey="1"
                  onChange={episodeChanage}
                  activeKey={tabIndex}
                >
                  {allEpisode.length !== 0 &&
                    allEpisode.map((episode, i) => {
                      return (
                        <TabPane
                          tab={`Episode ${i + 1}`}
                          key={JSON.stringify(i + 1)}
                          disabled={
                            isGenerating && tabIndex !== JSON.stringify(i + 1)
                          }
                        >
                          <Row gutter={[16, 8]}>
                            <Col xs={24} sm={24} md={12}>
                              <Form.Item
                                required={false}
                                colon={false}
                                className="no_bottom_margin"
                              >
                                {getFieldDecorator('cover_id' + i, {
                                  initialValue: episode.cover.id || '',
                                  rules: [
                                    {
                                      required: true,
                                      message: t('v4:upload_podcast_cover')
                                    }
                                  ]
                                })(
                                  <ImageSelect
                                    isReadOnly={isGenerating}
                                    tooltip={t('v4:info_episode')}
                                    form={form}
                                    label={t('v4:cover_picture')}
                                    coverInput={
                                      episode.cover.id ? episode.cover : null
                                    }
                                    onCoverChange={cover =>
                                      setCoverImage(cover, i)
                                    }
                                  />
                                )}
                              </Form.Item>
                              <Form.Item
                                label={t('v4:podcast_eposode_title')}
                                colon={false}
                                required={false}
                              >
                                {getFieldDecorator('title' + i, {
                                  initialValue: episode.title || '',
                                  rules: [
                                    {
                                      required: true,
                                      message: t('v4:enter_podcast_title')
                                    }
                                  ]
                                })(
                                  <Input
                                    disabled={isGenerating}
                                    onChange={e => {
                                      let title = e.target.value
                                      changeEpisodeTitle(title, i)
                                    }}
                                  />
                                )}
                              </Form.Item>
                              <Form.Item
                                label={t('v4:podcast_episode_des')}
                                colon={false}
                                required={false}
                              >
                                {getFieldDecorator('description' + i, {
                                  initialValue: episode.description || '',
                                  rules: [
                                    {
                                      required: true,
                                      message: t('v4:enter_podcast_episode_des')
                                    }
                                  ]
                                })(
                                  <TextEditor
                                    value={episode.description}
                                    onChange={data => {
                                      const plainText = data.replace(
                                        /<\/?[^>]+(>|$)/g,
                                        ''
                                      )
                                      const decodeEntities = str => {
                                        const textarea = document.createElement(
                                          'textarea'
                                        )
                                        textarea.innerHTML = str
                                        return textarea.value
                                      }
                                      const decodedText = decodeEntities(
                                        plainText
                                      )
                                      setEditorDescription(data, decodedText, i)
                                    }}
                                  />
                                )}
                              </Form.Item>
                              <div
                                style={{
                                  border: '1px solid #E0E0E0',
                                  borderRadius: '8px',
                                  padding: '2.4rem 2.4rem 0 2.4rem',
                                  marginBottom: '2.4rem',
                                  width: '100%'
                                }}
                              >
                                {episode.speakers.map(
                                  (speaker, speakerIndex) => {
                                    return (
                                      <Row
                                        gutter={[16, 8]}
                                        key={`${i}${speaker}${speakerIndex}`}
                                      >
                                        <Col xs={12} sm={12} md={9} lg={9}>
                                          <Form.Item
                                            label={
                                              speakerIndex === 0
                                                ? t('v4:name_of_host')
                                                : `${t(
                                                  'v5:name_of_the_guest'
                                                )}.${speakerIndex}`
                                            }
                                            colon={false}
                                            required={false}
                                          >
                                            {getFieldDecorator(speaker, {
                                              initialValue: speaker
                                            })(<Input disabled />)}
                                          </Form.Item>
                                        </Col>
                                        <Col xs={12} sm={12} md={7} lg={7}>
                                          <Form.Item
                                            label={t('v4:voice')}
                                            colon={false}
                                            required={false}
                                          >
                                            {getFieldDecorator(
                                              'voice_e' +
                                              i +
                                              '_s' +
                                              speakerIndex,
                                              {
                                                initialValue:
                                                  voiceList[0].voice_id ||
                                                  undefined
                                              }
                                            )(
                                              <Select
                                                size="large"
                                                disabled={isGenerating}
                                              >
                                                {voiceList.map((el, i) => {
                                                  return (
                                                    <Option
                                                      value={el.voice_id}
                                                      key={i}
                                                    >
                                                      <Row
                                                        type="flex"
                                                        justify="space-between"
                                                        align="middle"
                                                      >
                                                        <Col span={24}>
                                                          <div
                                                            style={{
                                                              display: 'flex',
                                                              alignItems:
                                                                'center'
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                fontWeight:
                                                                  'bolder',
                                                                color:
                                                                  el.labels &&
                                                                    el.labels
                                                                      .gender ===
                                                                    'male'
                                                                    ? '#1890ff'
                                                                    : '#eb2f96',
                                                                minWidth: '15px'
                                                              }}
                                                            >
                                                              {el.labels &&
                                                                el.labels
                                                                  .gender ===
                                                                'male'
                                                                ? '♂'
                                                                : el.labels &&
                                                                  el.labels
                                                                    .gender ===
                                                                  'female'
                                                                  ? '♀'
                                                                  : ''}
                                                            </span>{' '}
                                                            {el.category ===
                                                              'cloned' && (
                                                                <span>
                                                                  {(!isVoiceDeleating.status ||
                                                                    isVoiceDeleating.voice_id !==
                                                                    el.voice_id) && (
                                                                      <DeleteOutlined
                                                                        onClick={e => {
                                                                          e.stopPropagation()
                                                                          deleteVoice(
                                                                            el.voice_id,
                                                                            i,
                                                                            speakerIndex
                                                                          )
                                                                        }}
                                                                        style={{
                                                                          fontSize: 16,
                                                                          color:
                                                                            'red',
                                                                          margin:
                                                                            '5px'
                                                                        }}
                                                                      />
                                                                    )}
                                                                  {isVoiceDeleating.status &&
                                                                    isVoiceDeleating.voice_id ===
                                                                    el.voice_id && (
                                                                      <LoadingOutlined
                                                                        style={{
                                                                          fontSize: 16,
                                                                          color:
                                                                            'red',
                                                                          margin:
                                                                            '5px'
                                                                        }}
                                                                      />
                                                                    )}
                                                                </span>
                                                              )}
                                                            {el.name}
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </Option>
                                                  )
                                                })}
                                              </Select>
                                            )}
                                          </Form.Item>
                                        </Col>
                                        <Col xs={12} sm={12} md={6} lg={6}>
                                          <Form.Item
                                            label=""
                                            colon={false}
                                            required={false}
                                          >
                                            <Button
                                              style={{ marginTop: '25px' }}
                                              loading={
                                                isVoiceLoading.id === speaker &&
                                                isVoiceLoading.status
                                              }
                                              disabled={
                                                (isVoiceLoading.id !==
                                                  speaker &&
                                                  isVoiceLoading.status) ||
                                                isGenerating
                                              }
                                              onClick={() => {
                                                setOpenAudioModal({
                                                  id: speaker,
                                                  open: true,
                                                  src: '',
                                                  index: i,
                                                  speakerIndex: speakerIndex
                                                })
                                              }}
                                            >
                                              <PlusCircleOutlined
                                                style={{ color: '#5057D5' }}
                                              />
                                              {t('v5:library')}
                                            </Button>
                                          </Form.Item>
                                        </Col>
                                        <Col xs={12} sm={12} md={2} lg={2}>
                                          <Form.Item
                                            label=""
                                            colon={false}
                                            required={false}
                                            style={{ marginTop: '25px' }}
                                          >
                                            <SoundOutlined
                                              onClick={() => {
                                                listenSample(
                                                  speaker,
                                                  i,
                                                  speakerIndex
                                                )
                                              }}
                                              style={{
                                                color: '#5057D5',
                                                fontSize: 20,
                                                padding: 6
                                              }}
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                    )
                                  }
                                )}
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'left',
                                  alignItems: 'center',
                                  border: '1px solid #E0E0E0',
                                  borderRadius: '8px',
                                  padding: '0 2.4rem',
                                  marginBottom: '2.4rem',
                                  width: '100%'
                                }}
                              >
                                <div
                                  style={{
                                    color: '#212121 !important',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    width: '55px'
                                  }}
                                >
                                  {t('v4:music')}
                                </div>
                                <div
                                  style={{
                                    width: `calc(100% - 187px)`,
                                    paddingTop: '2.4rem'
                                  }}
                                >
                                  <Form.Item
                                    colon={false}
                                    required={false}
                                    style={{ padding: 0 }}
                                  >
                                    {getFieldDecorator('music_id' + i, {
                                      initialValue:
                                        formValues.music || undefined,
                                      rules: [
                                        {
                                          required: true,
                                          message: t('v4:rule_select_music')
                                        }
                                      ]
                                    })(
                                      <Select
                                        disabled={isGenerating}
                                        placeholder={t('v4:select_music')}
                                        size="large"
                                        onChange={selectMusic}
                                        allowClear
                                      >
                                        {musicList.map((music, inum) => {
                                          return (
                                            <Option value={music.id} key={inum}>
                                              {music.filename || music.title}
                                            </Option>
                                          )
                                        })}
                                      </Select>
                                    )}
                                  </Form.Item>
                                </div>
                                <div
                                  style={{
                                    width: '100px',
                                    display: 'flex',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <Button
                                    loading={openMusicModal.isUploading}
                                    disabled={isGenerating}
                                    onClick={() => {
                                      setIsPaused(true)
                                      setMusicModal({
                                        ...openMusicModal,
                                        open: true,
                                        index: i
                                      })
                                    }}
                                  >
                                    <PlusCircleOutlined
                                      style={{ color: '#5057D5' }}
                                    />
                                    {t('buttons:add')}
                                  </Button>
                                </div>
                                <div
                                  style={{
                                    width: '32px'
                                  }}
                                >
                                  {IsPaused ? (
                                    <Tooltip
                                      placement="left"
                                      title={t('v4:play_the_music')}
                                      arrow
                                    >
                                      <MutedOutlined
                                        onClick={() => {
                                          !isGenerating && listenMusic(false, i)
                                        }}
                                        style={{
                                          color: '#676973',
                                          fontSize: 20,
                                          padding: 6
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      placement="left"
                                      title={t('v4:stop_the_music')}
                                      arrow
                                    >
                                      <SoundOutlined
                                        onClick={() => {
                                          listenMusic(true, i)
                                        }}
                                        style={{
                                          color: '#5057D5',
                                          fontSize: 20,
                                          padding: 6
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col xs={24} sm={24} md={12}>
                              <Form.Item
                                colon={false}
                                required={false}
                                label={t('v4:context')}
                                className="no_bottom_margin"
                              >
                                <div
                                  id="scrollableDiv"
                                  style={{
                                    height: 955,
                                    overflowY: 'auto',
                                    borderRadius: 10,
                                    padding: '1.2rem',
                                    border:
                                      '1px solid rgba(140, 140, 140, 0.35)'
                                  }}
                                >
                                  <List
                                    dataSource={episode.content}
                                    renderItem={(item, contentIndex) => (
                                      <List.Item
                                        key={i}
                                        actions={[
                                          !isGenerating &&
                                          ((isEdit.contentIndex !==
                                            contentIndex &&
                                            isEdit.index !== i) ||
                                            !isEdit.status) && (
                                            <a
                                              key="list-loadmore-edit"
                                              onClick={() => {
                                                setIsEdit({
                                                  index: i,
                                                  contentIndex: contentIndex,
                                                  context: item.context,
                                                  status: true
                                                })
                                              }}
                                            >
                                              {t('buttons:edit')}
                                            </a>
                                          ),
                                          !isGenerating &&
                                          isEdit.index === i &&
                                          isEdit.contentIndex ===
                                          contentIndex &&
                                          isEdit.status && (
                                            <a
                                              key="list-loadmore-save"
                                              onClick={() => {
                                                updateContext(i, contentIndex)
                                              }}
                                            >
                                              {t('buttons:save')}
                                            </a>
                                          ),
                                          !isGenerating &&
                                          isEdit.index === i &&
                                          isEdit.contentIndex ===
                                          contentIndex &&
                                          isEdit.status && (
                                            <a
                                              key="list-loadmore-cancel"
                                              onClick={() => {
                                                setIsEdit({
                                                  index: -1,
                                                  contentIndex: -1,
                                                  context: '',
                                                  status: false
                                                })
                                              }}
                                            >
                                              {t('buttons:cancel')}
                                            </a>
                                          )
                                        ].filter(Boolean)}
                                      >
                                        <List.Item.Meta
                                          avatar={
                                            <Avatar
                                              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                                                item.speaker
                                              )}`}
                                            />
                                          }
                                          title={
                                            <div>
                                              <a>{item.speaker}</a>
                                            </div>
                                          }
                                          description={
                                            isEdit.index === i &&
                                              isEdit.contentIndex ===
                                              contentIndex &&
                                              isEdit.status ? (
                                              <Input.TextArea
                                                rows={3}
                                                defaultValue={isEdit.context}
                                                onChange={e =>
                                                  handleInputChange(e)
                                                }
                                              />
                                            ) : (
                                              item.context
                                            )
                                          }
                                        />
                                      </List.Item>
                                    )}
                                  />
                                </div>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <div className="discussion-machine-main-body-action">
                                <div className="generate-btn">
                                  <Tooltip
                                    placement="left"
                                    title={
                                      episode.description
                                        ? t(
                                          'v4:generate_audio_content_selected_voice'
                                        )
                                        : t(
                                          'v4:required_field_before_submitting'
                                        )
                                    }
                                    arrow
                                  >
                                    <span>
                                      <Button
                                        type="primary"
                                        className="rounded"
                                        loading={isGenerating}
                                        onClick={() => {
                                          generateAudio(i)
                                        }}
                                      >
                                        {episode.link
                                          ? t('v4:regenerate_voice')
                                          : t('v4:generate_voice')}
                                      </Button>
                                    </span>
                                  </Tooltip>
                                </div>
                                <div className="generate-audio">
                                  {episode.link && (
                                    <ReactPlayer
                                      url={episode.link}
                                      playing={
                                        !isSaving &&
                                        tabIndex === JSON.stringify(i + 1)
                                      }
                                      controls={true}
                                      width="100%"
                                      height="50px"
                                      config={{
                                        file: {
                                          forceAudio: true
                                        }
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </TabPane>
                      )
                    })}
                </Tabs>
              </Fragment>
            )}
          </Form>
        </div>
      </div>
    </Modal>
  )
}

export default Form.create({ name: 'podcast_form' })(DiscussionCreateMachine)
